/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SupplementalLocale } from './SupplementalLocale';
import {
    SupplementalLocaleFromJSON,
    SupplementalLocaleFromJSONTyped,
    SupplementalLocaleToJSON,
} from './SupplementalLocale';
import type { SupplementalRecipient } from './SupplementalRecipient';
import {
    SupplementalRecipientFromJSON,
    SupplementalRecipientFromJSONTyped,
    SupplementalRecipientToJSON,
} from './SupplementalRecipient';

/**
 * 
 * @export
 * @interface SupplementalAccountPackageRecipient
 */
export interface SupplementalAccountPackageRecipient {
    /**
     * 
     * @type {string}
     * @memberof SupplementalAccountPackageRecipient
     */
    recipient_id: string;
    /**
     * 
     * @type {string}
     * @memberof SupplementalAccountPackageRecipient
     */
    account_uuid: string;
    /**
     * 
     * @type {string}
     * @memberof SupplementalAccountPackageRecipient
     */
    quote_uuid: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplementalAccountPackageRecipient
     */
    policyholder_email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplementalAccountPackageRecipient
     */
    jira_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplementalAccountPackageRecipient
     */
    broker_uuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupplementalAccountPackageRecipient
     */
    broker_email?: string | null;
    /**
     * 
     * @type {SupplementalLocale}
     * @memberof SupplementalAccountPackageRecipient
     */
    locale: SupplementalLocale;
    /**
     * 
     * @type {string}
     * @memberof SupplementalAccountPackageRecipient
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplementalAccountPackageRecipient
     */
    updated_at?: string;
}

/**
 * Check if a given object implements the SupplementalAccountPackageRecipient interface.
 */
export function instanceOfSupplementalAccountPackageRecipient(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recipient_id" in value;
    isInstance = isInstance && "account_uuid" in value;
    isInstance = isInstance && "quote_uuid" in value;
    isInstance = isInstance && "locale" in value;

    return isInstance;
}

export function SupplementalAccountPackageRecipientFromJSON(json: any): SupplementalAccountPackageRecipient {
    return SupplementalAccountPackageRecipientFromJSONTyped(json, false);
}

export function SupplementalAccountPackageRecipientFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalAccountPackageRecipient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recipient_id': json['recipient_id'],
        'account_uuid': json['account_uuid'],
        'quote_uuid': json['quote_uuid'],
        'policyholder_email': !exists(json, 'policyholder_email') ? undefined : json['policyholder_email'],
        'jira_id': !exists(json, 'jira_id') ? undefined : json['jira_id'],
        'broker_uuid': !exists(json, 'broker_uuid') ? undefined : json['broker_uuid'],
        'broker_email': !exists(json, 'broker_email') ? undefined : json['broker_email'],
        'locale': SupplementalLocaleFromJSON(json['locale']),
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'updated_at': !exists(json, 'updated_at') ? undefined : json['updated_at'],
    };
}

export function SupplementalAccountPackageRecipientToJSON(value?: SupplementalAccountPackageRecipient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recipient_id': value.recipient_id,
        'account_uuid': value.account_uuid,
        'quote_uuid': value.quote_uuid,
        'policyholder_email': value.policyholder_email,
        'jira_id': value.jira_id,
        'broker_uuid': value.broker_uuid,
        'broker_email': value.broker_email,
        'locale': SupplementalLocaleToJSON(value.locale),
        'created_at': value.created_at,
        'updated_at': value.updated_at,
    };
}

